import ColorPicker from './ColorPicker';
import ColoredRenderer from './ColoredRenderer';

export default {
  __init__: [ 'colorPicker', 'coloredRenderer' ],
  colorPicker: [ 'type', ColorPicker ],
  coloredRenderer: [ 'type', ColoredRenderer ]
};